import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import {
  MrfiktivCustomerAccountControllerFindAllByPartnerIdParamsGen,
  MrfiktivPartnerCustomerUserViewModelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import customerAccountService from "@/services/shared/customerAccountService";

export const CustomerAccountPageDataProvider = new (class extends AbstractPageDataProvider<
  MrfiktivPartnerCustomerUserViewModelGen,
  MrfiktivCustomerAccountControllerFindAllByPartnerIdParamsGen
> {
  async getPage(
    query: MrfiktivCustomerAccountControllerFindAllByPartnerIdParamsGen
  ): Promise<IPageViewModel<MrfiktivPartnerCustomerUserViewModelGen>> {
    const res = await customerAccountService.findAll(query);

    return { meta: res.meta, data: res.data };
  }
})();
